import { useState, useMemo, useCallback } from 'react';
import { filterNodes } from '../helpers';

export const useHierarchySearch = ({
    nodes,
    filterFunction,
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    // Default filter function (searches in node name)
    const defaultFilterFunction = useCallback((node, term) => {
        if (!term) {
            return true;
        }

        const searchLower = term.toLowerCase();

        // Search in node name
        if (node.name && node.name.toLowerCase().includes(searchLower)) {
            return true;
        }

        // Search in node data fields
        if (node.data) {
            return Object.values(node.data).some(value => {
                if (typeof value === 'string') {
                    return value.toLowerCase().includes(searchLower);
                }
                return false;
            });
        }

        return false;
    }, []);

    // Get effective filter function
    const effectiveFilterFunction = filterFunction || defaultFilterFunction;

    // Filter nodes based on search term
    const filteredNodes = useMemo(() => {
        if (!searchTerm) {
            return nodes;
        }

        return filterNodes(nodes, searchTerm, effectiveFilterFunction);
    }, [nodes, searchTerm, effectiveFilterFunction]);

    return {
        searchTerm,
        setSearchTerm,
        filteredNodes,
    };
};
